<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
	name: 'Icon',
	inheritAttrs: false
});
</script>
<template>
	<i class="icon" :style="style" v-bind="$attrs">
		<slot/>
	</i>
</template>

<script setup lang="ts">
import { iconEmits, iconProps } from "../model";
import { useIcon } from "./use-icon";



const props = defineProps(iconProps)
const emit = defineEmits(iconEmits)

const {
	style
} = useIcon(props, emit)
</script>

<style lang="scss">
.icon {
	display: flex;
	align-items: center;
	justify-content: center;
	--size: 24px;

	svg {
		width: var(--size);
		height: var(--size);
	}

	&.is-loading {
		animation: rotating 2s linear infinite;
	}
}

@include keyframes(rotating) {
	0% { transform: rotate(0); }
	100% { transform: rotate(360deg); }
}
</style>
